import { Button } from "@material-ui/core";
import React from "react";

interface Props {
    user: {
        id: number;
        fingerprintEnrolled: boolean;
        palmEnrolled: boolean;
    }
    disabled?: boolean;
    onSetUserIdToEnroll: (id: number) => void;
    /**
     * When `true`, the label is just "Enroll" / "Re-Enroll" — used inside a
     * column already titled "Biometrics" (Elen QA on PAS-914). When `false`
     * (default), the full "Enroll Biometrics" / "Re-Enroll Biometrics" label
     * is shown — used in stand-alone contexts like BoxOwnerCard.
     */
    compact?: boolean;
}

export function EnrollBiometricsButton({
    user,
    disabled = false,
    onSetUserIdToEnroll,
    compact = false,
}: Props) {
    const isEnrolled = user.fingerprintEnrolled || user.palmEnrolled;
    const handleClick = () => {
        onSetUserIdToEnroll(user.id);
    }

    const label = compact
        ? (isEnrolled ? 'Re-Enroll' : 'Enroll')
        : (isEnrolled ? 'Re-Enroll Biometrics' : 'Enroll Biometrics');

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={handleClick}
            color={isEnrolled ? 'default' : 'primary'}
            disabled={disabled}
            style={{ minWidth: compact ? '110px' : '180px', whiteSpace: 'nowrap' }}
        >
            {label}
        </Button>
    )
}
